
const ProductData = [
    {
        id: 1,
        CardImg: require("../../img/category-img1.png"),
        CardHeading: "Delicious Burger",
        RealPrice: "$4.99",
        prePrice: "$5.99",
        ProductReview: "20 Reviews",
        CardProductDesc: " Lorem Ipsum is simply dummy text of the printing and typesetting industry.Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book."
    },
    {
        id: 2,
        CardImg: require("../../img/category-img2.png"),
        CardHeading: "Delicious Burger",
        RealPrice: "$4.99",
        prePrice: "$5.99",
        ProductReview: "20 Reviews",
        CardProductDesc: " Lorem Ipsum is simply dummy text of the printing and typesetting industry.Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book."
    },
    {
        id: 3,
        CardImg: require("../../img/category-img3.png"),
        CardHeading: "Delicious Burger",
        RealPrice: "$4.99",
        prePrice: "$5.99",
        ProductReview: "20 Reviews",
        CardProductDesc: " Lorem Ipsum is simply dummy text of the printing and typesetting industry.Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book."
    },
    {
        id: 4,
        CardImg: require("../../img/category-img4.png"),
        CardHeading: "Delicious Burger",
        RealPrice: "$4.99",
        prePrice: "$5.99",
        ProductReview: "20 Reviews",
        CardProductDesc: " Lorem Ipsum is simply dummy text of the printing and typesetting industry.Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book."
    },
    {
        id: 5,
        CardImg: require("../../img/category-img5.png"),
        CardHeading: "Delicious Burger",
        RealPrice: "$4.99",
        prePrice: "$5.99",
        ProductReview: "20 Reviews",
        CardProductDesc: " Lorem Ipsum is simply dummy text of the printing and typesetting industry.Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book."
    },
    {
        id: 6,
        CardImg: require("../../img/category-img6.png"),
        CardHeading: "Delicious Burger",
        RealPrice: "$4.99",
        prePrice: "$5.99",
        ProductReview: "20 Reviews",
        CardProductDesc: " Lorem Ipsum is simply dummy text of the printing and typesetting industry.Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book."
    },
    {
        id: 7,
        CardImg: require("../../img/category-img1.png"),
        CardHeading: "Delicious Burger",
        RealPrice: "$4.99",
        prePrice: "$5.99",
        ProductReview: "20 Reviews",
        CardProductDesc: " Lorem Ipsum is simply dummy text of the printing and typesetting industry.Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book."
    },
    {
        id: 8,
        CardImg: require("../../img/category-img2.png"),
        CardHeading: "Delicious Burger",
        RealPrice: "$4.99",
        prePrice: "$5.99",
        ProductReview: "20 Reviews",
        CardProductDesc: " Lorem Ipsum is simply dummy text of the printing and typesetting industry.Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book."
    }
]

export default ProductData